var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartMixed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55882 11C0.973294 11 0.5 11.448 0.5 12V17C0.5 17.552 0.973294 18 1.55882 18C2.14435 18 2.61765 17.552 2.61765 17V12C2.61765 11.448 2.14435 11 1.55882 11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85294 6.99994C6.26741 6.99994 5.79412 7.44795 5.79412 7.99995V17C5.79412 17.552 6.26741 18 6.85294 18C7.43847 18 7.91177 17.552 7.91177 17V7.99995C7.91177 7.44795 7.43847 6.99994 6.85294 6.99994Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1471 11C11.5615 11 11.0882 11.448 11.0882 12V17C11.0882 17.552 11.5615 18 12.1471 18C12.7326 18 13.2059 17.552 13.2059 17V12C13.2059 11.448 12.7326 11 12.1471 11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4412 6.99994C16.8556 6.99994 16.3824 7.44795 16.3824 7.99995V17C16.3824 17.552 16.8556 18 17.4412 18C18.0267 18 18.5 17.552 18.5 17V7.99995C18.5 7.44795 18.0267 6.99994 17.4412 6.99994Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55776 7.99995C1.86165 7.99995 2.16235 7.87695 2.37306 7.63995L6.85294 2.56192L11.3328 7.63995C11.7362 8.09595 12.5568 8.09595 12.9602 7.63995L18.2544 1.63992C18.6292 1.21592 18.5678 0.584912 18.1188 0.23191C17.6678 -0.122091 17.0018 -0.0640914 16.6269 0.359911L12.1471 5.43794L7.66718 0.359911C7.26377 -0.0960915 6.44318 -0.0960915 6.03977 0.359911L0.745647 6.35994C0.370824 6.78394 0.432235 7.41495 0.881176 7.76795C1.07918 7.92395 1.31847 7.99995 1.55776 7.99995Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartMixed);
export default __webpack_public_path__ + "static/media/chart-mixed.7ec9e1bace42bd34898e3c41068d5211.svg";
export { ForwardRef as ReactComponent };